import React from "react";
import { getColorFromUsername } from "utils/commonUtils";
import { ReactComponent as RemoveIcon } from "assets/icons/delete_fill_2.svg";

const Avatar = ({
  id,
  avatar,
  username,
  index,
  totalAvatars,
  onAvatarClick,
  avatarWidth = 34,
  parentWidth = 122,
  isList = false,
}) => {
  const totalWidth = avatarWidth * totalAvatars;

  const remainingSpace = parentWidth - totalWidth;
  let marginLeft = 0;
  if (totalAvatars > 1) {
    marginLeft = Math.min(10, remainingSpace / (totalAvatars - 1));
  }

  return (
    <div
      data-tooltip-id={"avatar_tooltip"}
      data-tooltip-content={username}
      onClick={() => onAvatarClick(id)}
      style={{
        minWidth: avatarWidth,
        width: avatarWidth,
        height: avatarWidth,
        marginTop: 5,
        marginLeft: index === 0 ? 0 : `${marginLeft}px`,
        backgroundColor: getColorFromUsername(username),
      }}
      className={`border-[1.5px] uppercase relative cursor-pointer border-[#FFE9C7] rounded-full ${
        avatar === null
          ? " text-white font-medium text-[13px] flex items-center justify-center"
          : ""
      }`}
    >
      {avatar === null ? (
        username.charAt(0)
      ) : (
        <img
          src={avatar}
          alt="avatar"
          className="w-full h-full object-cover rounded-full"
        />
      )}
      {!isList && (
        <div className="absolute top-0 right-0 left-0 bottom-0 flex items-center justify-center p-1 opacity-0 bg-[#FF0000B2] rounded-full hover:opacity-100 transition-opacity duration-300 ease-in-out">
          <RemoveIcon className="text-white w-5 h-5 fill-white" />
        </div>
      )}
    </div>
  );
};

export default Avatar;
